import { MarkSpec } from 'prosemirror-model';

import { BaseExtension, extensionType } from '@lyearn/lygo-core';

import plugins from './plugins';
import { getHexVal } from './utils';

export default class Color extends BaseExtension {
  get schema(): MarkSpec {
    return {
      attrs: {
        color: {
          default: '#000000',
        },
        backgroundColor: {
          default: 'transparent',
        },
      },
      parseDOM: [
        {
          tag: 'span.withColor',
          getAttrs: (element) => {
            const { color: _color, backgroundColor: _backgroundColor } = (element as HTMLElement)
              .style;
            const color = getHexVal(_color);
            const backgroundColor =
              _backgroundColor === 'transparent' ? 'transparent' : getHexVal(_backgroundColor);

            const attrs = {
              color,
              backgroundColor,
            };
            return attrs;
          },
        },
      ],
      toDOM: (node) => [
        'span',
        {
          style: `color: ${node.attrs.color}; background-color: ${node.attrs.backgroundColor}`,
          class: 'withColor',
        },
        0,
      ],
    };
  }

  get type(): string {
    return extensionType.mark;
  }

  get name(): string {
    return 'color';
  }

  plugins = plugins;
}
